import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SpinnerModule } from './../spinner/spinner.module';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent],
  imports: [SpinnerModule, CommonModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
export { ButtonComponent } from './button.component';
